import React, { useState, useEffect } from 'react';
import Modal from '../../../../../components/Modal';
import PropTypes from 'prop-types';
import DropDown from '../../../../../components/DropDown';
import { useGetAssignmentFoldersMutation } from '../../../../../features/authentication/authApiSlice';
import { useGetParentFoldersMutation } from '../../../../../features/authentication/assignApiSlice';
import { useAssignmentContext } from '../../../../assignments/context';
import CustomToast from '../../../../../components/Toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons';
import ConfirmationModal from '../../../../../components/ConfirmationPopUp';
import { Tooltip } from 'react-bootstrap';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { useMoveAssignmentsToFolderMutation } from '../../../../../features/authentication/assignmentApislice';
import ActivityTypes from '../../../../../enums/activityTypes';
import { useActivityContext } from '../../../../activities/context';
import { useMoveActivitiesToFolderMutation } from '../../../../../features/authentication/activityApiSlice';

const MoveMenuModal = ({ modalData, setModalData, fromMoreActions, activityType }) => {
  const [getAllFolders] = useGetAssignmentFoldersMutation();
  const [getAllParents] = useGetParentFoldersMutation();
  const [moveAssignmentToFolder] = useMoveAssignmentsToFolderMutation();
  const [moveActivitiesToFolder] = useMoveActivitiesToFolderMutation();
  const [selectedFolderId, setSelectedFolderId] = useState(-2);
  const [selectedParentId, setSelectedParentId] = useState(-1);
  const [allFolders, setAllFolders] = useState([]);
  const [allParents, setAllParents] = useState([]);
  const [newFolder, setNewFolder] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [confirmNotification, setConfirmNotification] = useState(false);
  const [folderCreated, setFolderCreated] = useState(new Date().getSeconds());
  const selectedAssignment = useAssignmentContext();
  const activityContext = useActivityContext();

  const { assignmentId } = useAssignmentContext();

  const getAllFoldersAsync = async () => {
    try {
      const allFoldersResponse = await getAllFolders().unwrap();
      const folderArray = [];
      allFoldersResponse.map((item) => {
        const obj = {
          id: item.folderID,
          name: item.description
        };
        folderArray.push(obj);
      });
      const objData = {
        id: -2,
        name: 'New Folder'
      };
      let folderArrayResponse = [objData, ...folderArray];
      if(activityType == ActivityTypes.FlashCard){
        folderArrayResponse = folderArrayResponse.map(item => ({
          ...item,
          name: item.name.replace(/Shared Assignments?/i, 'Shared Flashcards')
        }));
      }
      setAllFolders(folderArrayResponse);
      setSelectedFolderId(folderArrayResponse[0].id);
    } catch (error) {
      console.log(error);
    }
  };

  const getAllParentsAsync = async () => {
    try {
      const allParentsResponse = await getAllParents().unwrap();
      const parentArray = [];
      allParentsResponse.map((item) => {
        const obj = {
          id: item.folderID,
          name: item.description
        };
        parentArray.push(obj);
      });
      const objData = {
        id: -1,
        name: 'No Parent'
      };
      const parentArrayResponse = [objData, ...parentArray];
      setAllParents(parentArrayResponse);
      setSelectedParentId(parentArrayResponse[0].id);
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectFolder = (event) => {
    const folderId = parseInt(event.target.value);
    setSelectedFolderId(folderId);
  };

  const handleSelectParent = (event) => {
    const parentId = parseInt(event.target.value);
    setSelectedParentId(parentId);
  };

  const handleNewFolder = (event) => {
    const folderName = event.target.value;
    setNewFolder(folderName);
  };

  const moveConfirmationHandler = () => {
    if (selectedFolderId === -2 && newFolder === '') {
      CustomToast('Please check new folder name is given', 'error');
    } else {
      setConfirmNotification(true);
    }
  };

  const showConfirmation = () => {
    if (!isLoading) {
      setIsLoading(true);
      moveDataHandler();
    }
  };

  const moveDataHandler = async () => {
    setConfirmNotification(false);
    const parentId = selectedParentId === -1 ? 0 : selectedParentId;
    try {
      const options = {
        folderId: selectedFolderId,
        parentId: parentId,
        newFolder: newFolder
      };
      
      if(activityType == ActivityTypes.FlashCard){
        options.assignmentIds = !fromMoreActions ? activityContext.assignedData?.map((item) => item.assignmentId) : [activityContext.activityId];
      }
      else{
        options.assignmentIds = !fromMoreActions ? selectedAssignment.assignedData?.map((item) => item.assignmentId) : [assignmentId];
      }
      
      if((activityType == ActivityTypes.Assignment && selectedAssignment.isAllSelected) || (activityType == ActivityTypes.FlashCard && activityContext.isAllSelected)){
        options.assignmentIds = [-1];
        const filters = {
          assignmentStatus : activityType == ActivityTypes.FlashCard ? activityContext.filters.activityStatus : selectedAssignment.filters.assignmentStatus,
          assignedVia:activityType == ActivityTypes.FlashCard? [] : selectedAssignment.filters.assignedVia,
          courseId:activityType == ActivityTypes.FlashCard ? activityContext.filters.courseId : selectedAssignment.filters.courseId,
          folderId: activityType == ActivityTypes.FlashCard ? activityContext.filters.folderId : selectedAssignment.filters.folderId,
          searchText: activityType == ActivityTypes.FlashCard ? activityContext.filters.selectedKeyWord : selectedAssignment.filters.selectedKeyWord
        };
        options.filters = filters;
        options.activityType = activityType;
      }
     
      if(activityType == ActivityTypes.FlashCard)
      {
        var response = await moveActivitiesToFolder(options).unwrap();
        if(options.folderId === -2) {
          activityContext.setFolderUpdateStatus(true);
        }
        activityContext.setFilters((prev) => ({
          ...(prev || {}),
          folderId: response.folderId
        }));
        activityContext.setSelectedFolderId(response.folderId);
      }
      else{
        response = await moveAssignmentToFolder(options).unwrap();
        if(options.folderId === -2) {
          selectedAssignment.setFolderUpdateStatus(true);
        }
        selectedAssignment.setFilters((prev) => ({
          ...(prev || {}),
          folderId: response.folderId
        }));
        selectedAssignment.setSelectedFolderId(response.folderId);
        selectedAssignment.setSearch(true);
      }
      
      setIsLoading(false);    
      CustomToast(`${activityType == ActivityTypes.FlashCard ? 'Flashcard' : 'Assignment'} Moved Successfully`, 'success');
      resetMove();
      setModalData(false);
      setFolderCreated(new Date().getSeconds());
      if(activityType ==  ActivityTypes.FlashCard){
        activityContext.setAssignedDataStatus(new Date().getSeconds());
        activityContext.setAssignedData([]);
      }
      else{
        selectedAssignment.setAssignedDataStatus(new Date().getSeconds());
        selectedAssignment.setAssignedData([]);
        selectedAssignment.setAssignedName([]);
        selectedAssignment.setAssignmentId('');
        selectedAssignment.setAssignedCourseName([]);
      }
    } catch (ex) {
      console.log(ex);
      setIsLoading(false);
    }
  };

  const resetMove = () => {
    setSelectedFolderId(-2);
    setSelectedParentId(-1);
    setNewFolder('');
  };

  useEffect(() => {
    getAllFoldersAsync();
    getAllParentsAsync();
  }, [folderCreated]);

  const getConfirmationText = () => {
    const context = activityType === ActivityTypes.FlashCard ? activityContext : selectedAssignment;
    const itemName = activityType === ActivityTypes.FlashCard ? 'flashcard' : 'assignment';
  
    if (context.isAllSelected)
      return `Are you sure that you want to move <strong>all ${itemName}(s)</strong> to the specified folder?`;
  
    if (context.assignedData.length > 1)
      return `Are you sure that you want to move checked <strong>${context.assignedData.length} ${itemName}(s)</strong> to the specified folder?`;

    return `Are you sure that you want to move this ${itemName} to the specified folder?`;
  };

  return (
    <Modal
      contentWidth="600px"
      isOpen={modalData}
      titleName={`Move Selected ${activityType == ActivityTypes.FlashCard ? 'Flashcards': 'Assignments'}`}
      onClose={() => {
        resetMove();
        setModalData(false);
      }}>
      <div>
        <DropDown
          label="Folder to move to"
          value={allFolders}
          onChangeHandler={(e) => handleSelectFolder(e)}
          selectedValue={selectedFolderId}
        />
        {selectedFolderId === -2 && (
          <div className="py-3">
            <div className="align-items-center d-flex gap-5">
              <div className="d-flex">
                <div>
                  <DropDown
                    label="Parent folder"
                    value={allParents}
                    onChangeHandler={(e) => handleSelectParent(e)}
                    selectedValue={selectedParentId}
                  />
                </div>
                <OverlayTrigger
                  key="parent-folder-info"
                  placement="top"
                  overlay={
                    <Tooltip id="parent-tooltip" className="folder-info">
                      To move to a subfolder select a parent folder from the dropdown. If you wish
                      to create a new parent and subfolder you should enter the folder name as
                      parent/subfolder. The new parent folder will automatically be created. Only
                      one sublevel is allowed.
                    </Tooltip>
                  }>
                  <FontAwesomeIcon icon={faCircleQuestion} className="move-help" />
                </OverlayTrigger>
              </div>
              <div className="col-6">
                <label htmlFor="moveFolderName" className="form-label">
                  New folder name
                </label>
                <input
                  type="text"
                  className="form-control"
                  placeholder=" "
                  name="moveFolderName"
                  id="moveFolderName"
                  onChange={(e) => handleNewFolder(e)}
                  required
                />
              </div>
            </div>
          </div>
        )}
        <div className="d-flex justify-content-end mt-3 gap-3 align-items-center">
          <button
            className="btn btn-castleGray print-btn"
            disabled={isLoading}
            onClick={() => {
              resetMove();
              setModalData(false);
            }}>
            Cancel
          </button>
          <button className="btn btn-castleRed print-btn" disabled={isLoading} onClick={moveConfirmationHandler}>
            Move
          </button>
        </div>
      </div>
      <ConfirmationModal
        isOpen={confirmNotification}
        onClose={() => setConfirmNotification(false)}
        onSave={() => showConfirmation()}
        contentWidth={'35%'}
        buttonPosition={'center'}
        content={getConfirmationText()}
        cancelButton={'No'}
        confirmButton={'Yes'}
      />
    </Modal>
  );
};

MoveMenuModal.propTypes = {
  modalData: PropTypes.bool,
  setModalData: PropTypes.func,
  fromMoreActions: PropTypes.bool,
  activityType: PropTypes.number
};

export default MoveMenuModal;
